<div
  class="atlas-navbar__language-list-item__container"
  [class.atlas-navbar__language-list-item__container--current-language]="isCurrentLanguage | async"
  >
  <a class="atlas-navbar__language-list-item" (click)="selectLanguage()">
    <ng-content *ngTemplateOutlet="item"></ng-content>
  </a>

  @if (isCurrentLanguage | async) {
    <i class="material-icons atlas-navbar__language-list-item__icon">check</i>
  }
</div>

<ng-template #item>
  @if (!language().flag) {
    <i class="atlas-navbar__language-list-item__icon material-icons">language</i>
  }
  @if (language().flag) {
    <span class="atlas-navbar__language-language-list-item__flag">
      {{ language().flag }}
    </span>
  }
  @if (languageLabels(); as labels) {
    <div class="atlas-navbar__language-list-item__language-details">
      <div class="atlas-navbar__language-list-item__language-details__target-language">
        {{ labels.target | translate }}
      </div>
      <div
        class="atlas-navbar__language-list-item__language-details__current-language"
        [ngClass]="{ promote: !labels.target }"
        >
        {{ labels.current | translate }}
      </div>
    </div>
  }
</ng-template>
